import { render, staticRenderFns } from "./CadastroRRM.vue?vue&type=template&id=5c892c32&scoped=true"
import script from "./CadastroRRM.vue?vue&type=script&lang=js"
export * from "./CadastroRRM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c892c32",
  null
  
)

export default component.exports